﻿import { IOrderableTreeItem } from "@/components/OrderableTree/interfaces";
import { IMilestoneTemplate } from "@/interfaces";

export const buildTreeDataRecursive = (
  milestones: IMilestoneTemplate[],
  parentId?: string
): IOrderableTreeItem<IMilestoneTemplate>[] =>
  milestones
    .map((milestone) => {
      const node: IOrderableTreeItem<IMilestoneTemplate> = {
        text: milestone.name,
        id: milestone.id,
        parentId: parentId,
        data: milestone,
      };

      if (!milestone.childMilestones) return [node];

      return [
        node,
        ...buildTreeDataRecursive(milestone.childMilestones, milestone.id),
      ];
    })
    .flat();
